'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var nthBitHeader = require('@narvar/nth-bit-header');
var Select = require('@narvar/nth-block-select');
var TextArea = require('@narvar/nth-block-text-area');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var Box = require('../../../../../../common/components/layout/Box/Box.js');
var ClaimDetailsProvider = require('../../ClaimDetailsProvider.js');
var ActionOption = require('./ActionOption/ActionOption.js');
var Button = require('@narvar/nth-block-button');
var ClaimStatusChip = require('../../../../components/ClaimStatusChip/ClaimStatusChip.js');
var ClaimDetailsDescription = require('../../components/ClaimDetailsDescription.js');
var Typography = require('../../../../../../common/components/Typography.js');
var index$1 = require('../../../../../../common/theme/index.js');
var index = require('../../../../../../common/components/Icon/index.js');
var useTitanAnalytics = require('../../../../../../common/providers/titan/useTitanAnalytics.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Select__default = /*#__PURE__*/_interopDefaultLegacy(Select);
var TextArea__default = /*#__PURE__*/_interopDefaultLegacy(TextArea);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);

const Review = _ref => {
  let {
    claim
  } = _ref;
  const titan = useTitanAnalytics["default"]();
  const {
    handleUpdateClaim,
    overturnReasonOptionsForAction
  } = ClaimDetailsProvider.useClaimDetails();
  const {
    claimsClaimDetailsReviewTitle,
    claimsClaimDetailsReviewOptionApprove,
    claimsClaimDetailsReviewOptionDeny,
    claimsClaimDetailsReviewOptionCancel,
    claimsClaimDetailsReviewOptionReview,
    claimsClaimDetailsReviewSubmit,
    claimsClaimDetailsReviewDetailsOutcome,
    claimsClaimDetailsReviewDetailsReviewer,
    claimsClaimDetailsReviewDetailsClosed,
    claimsClaimDetailsReviewRecommendedAction,
    claimsClaimDetailsReviewRecommendedActionAccepted,
    claimsClaimDetailsReviewActionReasonRequest,
    claimsClaimDetailsReviewActionReasonRequestDropdownLabel,
    claimsClaimDetailsReviewActionReasonRequestOtherLabel,
    claimsClaimDetailsReviewReasonForOverride
  } = nthHookTranslations.useTranslations();
  const options = [{
    type: 'Approve',
    icon: 'CheckMarkCircleFilled'
  }, {
    type: 'Deny',
    icon: 'IndeterminateCircleFilled'
  }, {
    type: 'Cancel',
    icon: 'XCircleFilled'
  }];
  const recommendedActionText = {
    Approve: claimsClaimDetailsReviewOptionApprove ?? '',
    Deny: claimsClaimDetailsReviewOptionDeny ?? '',
    Cancel: claimsClaimDetailsReviewOptionCancel ?? '',
    Review: claimsClaimDetailsReviewOptionReview ?? ''
  };
  const [selectedAction, setSelectedAction] = React.useState(undefined);
  const [overturnReason, setOverturnReason] = React.useState(undefined);
  const [overturnReasonDescription, setOverturnReasonDescription] = React.useState(undefined);
  const {
    recommendedAction,
    status,
    resolution
  } = claim;
  const claimResolved = !!resolution;
  const overturnReasonOptions = recommendedAction ? overturnReasonOptionsForAction(recommendedAction) : null;
  const requireOverturnReason = overturnReasonOptions && !!selectedAction && (recommendedAction === 'Approve' || recommendedAction === 'Deny' || recommendedAction === 'Cancel') && selectedAction !== recommendedAction;
  const requireOverturnReasonDescription = (overturnReason === null || overturnReason === void 0 ? void 0 : overturnReason.value) === 'OTHER';
  const submitEnabled = !!selectedAction && (requireOverturnReason ? !!overturnReason : true) && (requireOverturnReasonDescription ? !!overturnReasonDescription : true);
  React.useEffect(() => {
    // Track the checkout step viewed event when the overturn reason is shown
    if (requireOverturnReason) {
      titan === null || titan === void 0 ? void 0 : titan.track({
        event: 'checkout_step_viewed',
        properties: {
          step: 2,
          products: [{
            product_id: claim.id,
            category: claim.claimType,
            variant: claim.status
          }],
          extra_properties: [{
            key: 'review_action',
            value: selectedAction
          }, {
            key: 'recommended_review_action',
            value: recommendedAction
          }]
        }
      })
      // eslint-disable-next-line no-console
      .catch(e => console.error(e));
    }
  }, [requireOverturnReason, claim.id, claim.claimType, claim.status, recommendedAction, selectedAction, titan]);
  React.useEffect(() => {
    // Track the checkout step viewed event when the overturn reason is shown
    if (requireOverturnReasonDescription) {
      titan === null || titan === void 0 ? void 0 : titan.track({
        event: 'checkout_step_viewed',
        properties: {
          step: 3,
          products: [{
            product_id: claim.id,
            category: claim.claimType,
            variant: claim.status
          }],
          extra_properties: [{
            key: 'overturn_reason',
            value: 'Other'
          }, {
            key: 'review_action',
            value: selectedAction
          }, {
            key: 'recommended_review_action',
            value: recommendedAction
          }]
        }
      })
      // eslint-disable-next-line no-console
      .catch(e => console.error(e));
    }
  }, [requireOverturnReasonDescription, claim.id, claim.claimType, claim.status, recommendedAction, selectedAction, titan]);
  return /*#__PURE__*/React__default["default"].createElement(Box["default"], {
    gap: 4
  }, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.SmallHeader, {
    as: "h2"
  }, claimsClaimDetailsReviewTitle), claimResolved && /*#__PURE__*/React__default["default"].createElement(Box["default"], {
    gap: 3
  }, /*#__PURE__*/React__default["default"].createElement(ClaimDetailsDescription.ClaimDetailsDescriptionList, null, /*#__PURE__*/React__default["default"].createElement(Box["default"], {
    gap: 2
  }, /*#__PURE__*/React__default["default"].createElement(ClaimDetailsDescription.ClaimDetailsDescriptionRow, null, /*#__PURE__*/React__default["default"].createElement(ClaimDetailsDescription.ClaimDetailsDescriptionLabel, null, claimsClaimDetailsReviewDetailsOutcome), /*#__PURE__*/React__default["default"].createElement(ClaimDetailsDescription.ClaimDetailsDescriptionValue, null, /*#__PURE__*/React__default["default"].createElement(ClaimStatusChip["default"], {
    status: status
  }))), /*#__PURE__*/React__default["default"].createElement(ClaimDetailsDescription.ClaimDetailsDescriptionRow, null, /*#__PURE__*/React__default["default"].createElement(ClaimDetailsDescription.ClaimDetailsDescriptionLabel, null, claimsClaimDetailsReviewDetailsReviewer), /*#__PURE__*/React__default["default"].createElement(ClaimDetailsDescription.ClaimDetailsDescriptionValue, null, resolution.reviewer)), /*#__PURE__*/React__default["default"].createElement(ClaimDetailsDescription.ClaimDetailsDescriptionRow, null, /*#__PURE__*/React__default["default"].createElement(ClaimDetailsDescription.ClaimDetailsDescriptionLabel, null, claimsClaimDetailsReviewDetailsClosed), /*#__PURE__*/React__default["default"].createElement(ClaimDetailsDescription.ClaimDetailsDescriptionValue, null, resolution.resolvedOn)))), /*#__PURE__*/React__default["default"].createElement(Typography.PanelHeader, null, /*#__PURE__*/React__default["default"].createElement(Box["default"], {
    gap: 3,
    px: 2,
    style: {
      gridTemplateColumns: '1em 1fr',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    icon: "Sparkles",
    fill: index$1.colors.statusIndeterminate
  }), recommendedAction === resolution.action ? /*#__PURE__*/React__default["default"].createElement(Typography.CaptionTextDefault, null, claimsClaimDetailsReviewRecommendedActionAccepted) : /*#__PURE__*/React__default["default"].createElement("div", null, recommendedAction && /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement(Typography.CaptionTextDefault, {
    as: "span"
  }, claimsClaimDetailsReviewRecommendedAction), ":\xA0", /*#__PURE__*/React__default["default"].createElement(Typography.CaptionTextDefault, {
    as: "span",
    s: {
      color: index$1.colors.statusIndeterminateDark
    }
  }, recommendedActionText[recommendedAction])), recommendedAction !== 'Review' && /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement(Typography.CaptionTextDefault, {
    as: "span"
  }, claimsClaimDetailsReviewReasonForOverride), ":\xA0", /*#__PURE__*/React__default["default"].createElement(Typography.CaptionTextDefault, {
    as: "span",
    s: {
      color: index$1.colors.statusIndeterminateDark
    }
  }, resolution.actionReason)))))), !claimResolved && /*#__PURE__*/React__default["default"].createElement("form", {
    noValidate: true,
    onSubmit: e => {
      e.preventDefault();
      if (selectedAction) {
        handleUpdateClaim({
          action: selectedAction,
          actionReason: overturnReasonDescription ?? (overturnReason === null || overturnReason === void 0 ? void 0 : overturnReason.value) ?? null
        }).catch(() => {});
      }
    }
  }, /*#__PURE__*/React__default["default"].createElement(Box["default"], {
    gap: 2
  }, options.map(option => /*#__PURE__*/React__default["default"].createElement(ActionOption["default"], {
    key: option.type,
    selected: selectedAction === option.type,
    name: "resolutionAction",
    value: option.type,
    onChange: () => {
      titan === null || titan === void 0 ? void 0 : titan.track({
        event: 'checkout_started',
        properties: {
          products: [{
            product_id: claim.id,
            category: claim.claimType,
            variant: claim.status
          }],
          extra_properties: [{
            key: 'review_action',
            value: option.type
          }, {
            key: 'recommended_review_action',
            value: recommendedAction
          }]
        }
      })
      // eslint-disable-next-line no-console
      .catch(e => console.error(e));
      setOverturnReason(undefined);
      setOverturnReasonDescription(undefined);
      setSelectedAction(option.type);
    },
    title: recommendedActionText[option.type],
    recommended: recommendedAction === option.type,
    icon: option.icon
  })), requireOverturnReason && /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(Typography.CaptionTextDefault, null, claimsClaimDetailsReviewActionReasonRequest), /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      margin: '0 0 -1rem 0'
    }
  }, /*#__PURE__*/React__default["default"].createElement(Select__default["default"], {
    system: true,
    label: claimsClaimDetailsReviewActionReasonRequestDropdownLabel ?? '',
    options: overturnReasonOptions,
    name: "overturnReason",
    value: overturnReason,
    onChange: value => {
      titan === null || titan === void 0 ? void 0 : titan.track({
        event: 'checkout_step_completed',
        properties: {
          step: 2,
          products: [{
            product_id: claim.id,
            category: claim.claimType,
            variant: claim.status
          }],
          extra_properties: [{
            key: 'overturn_reason',
            value: value === null || value === void 0 ? void 0 : value.label
          }, {
            key: 'review_action',
            value: selectedAction
          }, {
            key: 'recommended_review_action',
            value: recommendedAction
          }]
        }
      })
      // eslint-disable-next-line no-console
      .catch(e => console.error(e));
      setOverturnReason(value ?? undefined);
    }
  }))), requireOverturnReasonDescription && /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("label", {
    htmlFor: "overturnReasonDescription"
  }, /*#__PURE__*/React__default["default"].createElement(Typography.CaptionTextDefault, null, claimsClaimDetailsReviewActionReasonRequestOtherLabel)), /*#__PURE__*/React__default["default"].createElement(TextArea__default["default"], {
    id: "overturnReasonDescription",
    value: overturnReasonDescription,
    onChange: e => setOverturnReasonDescription(e.target.value),
    maxLength: 150
  })), /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
    type: Button.ButtonType.submit,
    disabled: !submitEnabled
  }, claimsClaimDetailsReviewSubmit))));
};
var Review$1 = nthHookTranslations.withTranslationsProvider(Review, {
  translationKeys: ['claimsClaimDetailsReviewTitle', 'claimsClaimDetailsReviewOptionApprove', 'claimsClaimDetailsReviewOptionDeny', 'claimsClaimDetailsReviewOptionCancel', 'claimsClaimDetailsReviewOptionReview', 'claimsClaimDetailsReviewSubmit', 'claimsClaimDetailsReviewDetailsOutcome', 'claimsClaimDetailsReviewDetailsReviewer', 'claimsClaimDetailsReviewDetailsClosed', 'claimsClaimDetailsReviewRecommendedAction', 'claimsClaimDetailsReviewRecommendedActionAccepted', 'claimsClaimDetailsReviewActionReasonRequest', 'claimsClaimDetailsReviewActionReasonRequestDropdownLabel', 'claimsClaimDetailsReviewActionReasonRequestOtherLabel', 'claimsClaimDetailsReviewReasonForOverride']
});

exports["default"] = Review$1;
